const app = {
    state: {
        // 记录页面滚动位置
        scrollPos: {}
    },
    mutations: {
        'app:update'(state, payload) {
            for(let key in payload) {
                state[key] = payload[key]
            }
        },
        'app:update:scrollPos'(state, payload) {
            state.scrollPos[payload.key] = payload.value;
        }
    },
    actions: {

    },
    getters: {
        'app:scrollPos'(state) {
            return state.scrollPos;
        }
    }
};

export default app;



// WEBPACK FOOTER //
// ./src/common/store/module/app.js